export default "__VITE_ASSET__CM$HBy_e__"